document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  function moveElementForMobile() {
    const element = document.querySelector(".cpb-panels-tabs-wrapper");
    const desc = document.querySelector(".cpb-product-description");
    const title = document.querySelector(".cpb-product-title")

    if (window.innerWidth <= 768) {
        if (desc) {
          desc.after(element);
          element.classList.add('custom')
        } else {
          title.after(element)
          element.classList.add('custom')
        }
    }
  }
  
  moveElementForMobile();
})